import { QueryParams } from 'types/types'

const getCredentials = async () => {
  const response = await fetch('/cart?view=hmac')
  if (!response.ok) throw new Error(`Failed to fetch credentials`)

  const [credentials] = await response.json()
  if (
    !credentials?.hmac_signature ||
    !credentials?.timestamp ||
    !credentials?.sessionId
  ) {
    throw new Error('Invalid response received')
  }

  return credentials
}

export const proxy = async (
  path: string,
  queryParams: QueryParams,
  method: 'GET' | 'POST',
  body = {}
) => {
  try {
    const baseUrl = import.meta.env.VITE_PROXY_URL
    const params = new URLSearchParams(queryParams).toString()
    const url = `${baseUrl}${path}?${params}`

    const credentials = await getCredentials()
    if (!credentials) return

    const response = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
        'X-Pura-HMAC': credentials.hmac_signature,
        'X-Pura-Timestamp': credentials.timestamp,
        'X-Pura-SessionId': credentials.sessionId,
      },
      body: body ? JSON.stringify(body) : null,
    })

    if (!response.ok) {
      try {
        const errorData = await response.json()
        return {
          error: true,
          ...(errorData ?? {}),
        }
      } catch (jsonError) {
        console.error('Failed to parse error response JSON:', jsonError)
        return {
          error: true,
          message:
            response.statusText ||
            'Error response received, but body could not be parsed.',
        }
      }
    }

    const data = await response.json()
    if (data.status === 'error') {
      return {
        error: true,
        message: data.message ?? 'Invalid response received',
      }
    }

    return data
  } catch (error: any) {
    return { error: true, message: error.message }
  }
}
